exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form-field {\n  margin: 20px 0;\n  /*  &__label {\n    margin-bottom: 5px;\n    color: #333;\n    font-size: 16px;\n    font-weight: normal;\n    line-height: 1.6;\n  }*/\n}\n.login-form-field__input {\n  width: 100% !important;\n  height: 50px !important;\n}\n.login-form-field__input input {\n  background-color: hsla(0, 0%, 100%, 0.1);\n  color: #555 !important;\n  padding-left: 50px !important;\n  border-radius: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Login/components/InputLogin/InputLogin.less
// module id = 1055
// module chunks = 0